import { render } from "./Service.vue?vue&type=template&id=1394deea&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=1394deea&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1394deea"]])

export default __exports__